import React from "react";

type ColumnProps = { children: React.ReactNode; className?: string };

const Column = ({ children, className }: ColumnProps) => (
  <div className={`w-full max-w-3xl ${className || ""}`}>{children}</div>
);

export default Column;
